/**
 * `PartProcess` — the closed manufacturing-process enum, and `packages/shared`
 * is now its SINGLE OWNER (ADR-0117 D2).
 *
 * Before UID-346 this tuple existed in three hand-kept copies: the OpenAPI
 * `PartProcess` enum (`apps/api/openapi.yaml`), the api-side const tuple in
 * `apps/api/src/modules/parts-library/edit-part-config-policy.ts`, and the web
 * re-export in `apps/web/src/verticals/parts/edit-part-config-service.ts`. D2
 * collapses them onto this module: the api policy re-exports it, the web service
 * derives from it, and `apps/api/src/contract.test.ts` keeps the OpenAPI enum
 * pinned to the same members.
 *
 * It lives here rather than in `manufacturing-catalog.ts` because that file is
 * GENERATED from the ERP export — the enum is a contract token, not derived data,
 * and the generated catalog imports `PartProcess` from here.
 *
 * UID-93: extended to the 7 real Fictiv manufacturing processes; `tube_bending`
 * added for the real motorcycle-subframe demo BOM. Closed set, additive only.
 */
export const PART_PROCESSES = [
  'cnc_machining',
  'sheet_metal_fabrication',
  'injection_molding',
  'urethane_casting',
  '3d_printing',
  'compression_molding',
  'die_casting',
  'tube_bending',
] as const

export type PartProcess = (typeof PART_PROCESSES)[number]

const PROCESS_LOOKUP = new Set<string>(PART_PROCESSES)

/** True iff `value` is one of the eight canonical `PartProcess` enum tokens. */
export function isPartProcess(value: unknown): value is PartProcess {
  return typeof value === 'string' && PROCESS_LOOKUP.has(value)
}
